<template>
    <div class="main-nav-category">
        <nav class="nav-category">
            <ul class="menu-categores">
                <li class="btn-control"><a class="btn-add" @click.prevent="openSettings()"><i class="fa fa-cog"></i></a></li>
                <li v-for="(i, idx) in listMain" :key="idx">
                    <a :href="'#section-'+i.id" :title="i.name_cat" :data-id="i.id"
                    :class="[(getCatActive.id==i.id) ? 'active' : '', 'item-link-'+i.id]" @click.prevent="showmenu(i)">{{ i.name_cat }}</a>
                </li>
            </ul>
            <span class="indicador" id="indicador"></span>
        </nav>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    data(){
        return {
            listMain: [],
            categoryActive: null,
        };
    },
    created(){
        let t = this;
        // console.log('created getListCat', t.getListCat);
    },
    mounted(){
        let t = this;
        t.listMain = t.getListCat;
        t.categoryActive = t.getCatActive;
        if(t.getCatActive && t.getCatActive.id){
            t.$emit('startMenu', t.getCatActive.id);
        }
    },
    watch: {
        getListCat: function(newVal, oldVal){
            let t = this;
            if(newVal !== oldVal){
                t.listMain = newVal;
            }
        },
        getCatActive(newVal, oldVal){
            let t = this;
            if(newVal && newVal.id){
                t.$emit('clickItem', newVal.id);
            }
        }
    },
    computed: {
        ...mapGetters("ModApps/Marketea/", {
            getListCat: "get_bStore_listCat",
            getCatActive: "get_bStore_catActive",
        }),
    },
    methods: {
        openSettings(){
            this.$store.commit('ModApps/Marketea/set_menuTab_bStore', 'categories');
            this.$emit('clickAction', {name: 'bStore_setup', data: []})
        },
        showmenu(i){
            let t = this;
            t.categoryActive = i;
            t.$nextTick(() => {
                t.setStore('bStore_catActive', t.categoryActive);
            });
        },
        setStore(key, val){
            let t = this;
            t.$store.commit('ModApps/Marketea/set_bStoreValStorage', {key, val});
        },
    }
}
</script>
<style lang="scss" scoped></style>
